import { createContext } from 'react';

import type { HistogramSelectConfig } from '../types/histogram-props.js';

export const HistogramSelectConfigContext = createContext<
  HistogramSelectConfig | undefined
>(undefined);
